import { ApprovalStatus } from '@css-xp/apd-common';

export const statusToShow: { [key: string]: string } = {
  [ApprovalStatus.WAITING_FOR_REVIEW]: 'Waiting for review',
  [ApprovalStatus.IN_REVIEW]: 'In review',
  [ApprovalStatus.APPROVED]: 'Approved',
  [ApprovalStatus.REASONS_REQUESTED]: 'Reasons requested',
  [ApprovalStatus.REASONS_PROVIDED]: 'Reasons provided',
  [ApprovalStatus.DECLINED]: 'Declined',
  [ApprovalStatus.REQUEST_CANCELED]: 'Request canceled',
};
